/**
 * @file safe-legal-href.ts
 * @description Адрес документа на сайте без исключений (phase19.16, SB139).
 *
 * `legalDocumentHref` из shared бросает `RangeError`, если адрес не по
 * правилу (`LEGAL_SLUG_PATTERN`). В кабинете адрес строится и во время ввода
 * («cert-» — ещё не дописан), и из данных прежнего API, — страница не должна
 * падать: невалидный адрес → null, а подпись показывает правило.
 */

import { legalDocumentHref } from "@chaiberi/shared";

/** Адрес на сайте или null, если адрес пуст или не по правилу. */
export function safeLegalHref(slug: string): string | null {
  if (!slug) return null;
  try {
    return legalDocumentHref(slug);
  } catch {
    return null;
  }
}
